import { Tooltip } from "@excalidraw/excalidraw/components/Tooltip";
import { shield } from "@excalidraw/excalidraw/components/icons";

export const EncryptedIcon = () => {
  return (
    <span className="encrypted-icon tooltip" aria-label="End-to-end encrypted">
      <Tooltip label="End-to-end encrypted" long={true}>
        {shield}
      </Tooltip>
    </span>
  );
};
